import * as REDUX_TYPES from '../types'

export const resetNFT = () => {
  return {
    type: REDUX_TYPES.NFT.RESET,
  }
}

export const setCurrentIssue = (currentIssue) => {
  return {
    type: REDUX_TYPES.NFT.CURRENT_ISSUE,
    currentIssue,
  }
}

export const setMintRoyalty = (mintRoyalty) => {
  return {
    type: REDUX_TYPES.NFT.MINT_ROYALTY,
    mintRoyalty,
  }
}
export const setMintStage = (mintStage) => {
  return {
    type: REDUX_TYPES.NFT.MINT_STAGE,
    mintStage,
  }
}
export const setNFTMediaHash = (mediaHash) => {
  return {
    type: REDUX_TYPES.NFT.MEDIA_HASH,
    mediaHash,
  }
}
export const setNFTDescription = (description) => {
  return {
    type: REDUX_TYPES.NFT.DESCRIPTION,
    description,
  }
}
export const setNFTMessage = (nftMessage) => {
  return {
    type: REDUX_TYPES.NFT.MESSAGE,
    nftMessage,
  }
}
export const setNFTMessageId = (messageId) => {
  return {
    type: REDUX_TYPES.NFT.MESSAGE_ID,
    messageId,
  }
}
export const setNFTName = (name) => {
  return {
    type: REDUX_TYPES.NFT.NAME,
    name,
  }
}
export const setNFTPrice = (price) => {
  return {
    type: REDUX_TYPES.NFT.PRICE,
    price,
  }
}

export const setTokenId = (tokenId) => {
  return {
    type: REDUX_TYPES.NFT.TOKEN_ID,
    tokenId,
  }
}

export const updateNFT = (nft) => {
  return {
    type: REDUX_TYPES.NFT.UPDATE,
    nft
  }
}

